var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oneProjectRecords',{attrs:{"projectID":_vm.projectID,"uid":_vm.uid,"master":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }